// Port of api/fuel/app/classes/filter.php constants.
// These define the filter engine's type system.

var F = {

	// Filter modes
	MODE_STANDARD: 1,
	MODE_ADVANCED: 2,

	// Pseudo count types
	PSEUDO_GAME: 1,
	PSEUDO_COLLECTION: 2,
	PSEUDO_RATING: 3,
	PSEUDO_PLAY: 4,
	PSEUDO_LIST: 5,
	PSEUDO_USER: 6,
	PSEUDO_ACTIVITY: 7,

	// Owner types
	OWNER_USER: 1,
	OWNER_GROUP: 2,
	OWNER_BUDDIES: 3,

	NESTED_NONE: 0,
	NESTED_OFFICIAL: 1,
	NESTED_CUSTOM: 2,

	// Results per page
	PERPAGE: 48,

	// Filter types
	TYPE_GAMES: 1,
	TYPE_USERS: 2,
	TYPE_ACTIVITIES: 3,
	TYPE_LISTS: 4,

	TYPE_FOLDER: {
		1: 'games',
		2: 'users',
		3: 'activities',
		4: 'lists'
	},

	// Result types - what model the filter indexes
	RESULT_GAME: 1,
	RESULT_PLAY: 2,
	RESULT_RATING: 3,
	RESULT_COLLECTION: 4,
	RESULT_LIST: 6,
	RESULT_USER: 7,
	RESULT_ACTIVITY: 8,

	// Relation alias for each result type
	RESULT_RELATION: {
		1: 'g',
		2: 'p',
		3: 'r',
		4: 'c',
		6: 'l',
		7: 'u'
	},

	// Table name for each result type
	RESULT_TABLE: {
		1: 'game',
		2: 'play',
		3: 'rating',
		4: 'collection',
		6: 'list',
		7: 'user'
	},

	// Package types
	PACKAGE_GAME: 1,
	PACKAGE_PLAY: 2,
	PACKAGE_RATING: 3,
	PACKAGE_COLLECTION: 7,
	PACKAGE_LIST: 4,
	PACKAGE_USER: 5,
	PACKAGE_ACTIVITY: 6,

	PACKAGE_FOLDER: {
		1: 'game',
		2: 'play',
		3: 'rating',
		4: 'listing',
		5: 'user',
		6: 'activity',
		7: 'collection'
	},

	// Cache types
	CACHE_RATINGS: 1,
	CACHE_USERS: 2,
	CACHE_PLAYS: 3,
	CACHE_LISTS: 4,
	CACHE_LISTING: 5,
	CACHE_COLLECTION: 6,
	CACHE_ACTIVITY: 7,
	CACHE_INLINE: 8,
	CACHE_GAMES: 9,

	// Source types
	SOURCE_ALL: 'all',
	SOURCE_LIST: 'list',
	SOURCE_LIST_SORTED: 'list.sorted',
	SOURCE_COLLECTION: 'collection',
	SOURCE_PLAYS: 'plays',
	SOURCE_RATINGS: 'ratings',
	SOURCE_OTHER: 'other',

	SOURCE_TABLE: {
		'all': 'game',
		'collection': 'collection',
		'plays': 'play',
		'ratings': 'rating'
	},

	// Relation aliases
	RELATION_VERSION: 'v',
	RELATION_GAME: 'g',
	RELATION_PLAY: 'p',
	RELATION_RATING: 'r',
	RELATION_COMMENT: 'm',
	RELATION_COLLECTION: 'c',
	RELATION_LIST_EDITION: 'e',
	RELATION_LIST: 'l',
	RELATION_USER: 'u',

	// Table name for each relation alias
	RELATION_TABLE: {
		'g': 'game',
		'p': 'play',
		'r': 'rating',
		'v': 'game_version',
		'c': 'collection',
		'e': 'list_edition',
		'm': 'comment',
		'l': 'list',
		'u': 'user',
		'y': 'custom_rename',
		'z': 'custom_rename',
		'x': 'game_relation'
	},

	// Relations that are source tables
	RELATION_SOURCE: ['p', 'r', 'c'],

	// Relations that have user_id
	RELATION_USERS: ['p', 'r', 'c', 'm', 'rn', 'pn', 'ps', 'mn', 'cs', 'ce', 'z', 'y'],

	// Relations that have game_id
	RELATION_GAMES: ['p', 'r', 'c'],

	// Reverse lookup: table name -> relation alias
	TABLE_RELATION: {
		'game': 'g',
		'game!': 'g',
		'play': 'p',
		'rating': 'r',
		'game_version': 'v',
		'collection': 'c',
		'list_edition': 'e',
		'comment': 'm',
		'list': 'l',
		'user': 'u',
		'custom_rename': 'z',
		'game_relation': 'x'
	}

}

export default F
